import RespondentDetails from "./RespondentDetails";

export default RespondentDetails;
